import React, { useState, useRef, useEffect, ChangeEvent } from 'react';
import { FileObjTypes } from '../types';

type FilePickerProps = {
  id: string;
  allowMultiple: boolean;
  onHandleFiles: (files: FileObjTypes[]) => void;
  children: React.ReactNode;
};

const FilePicker = ({
  id,
  allowMultiple,
  onHandleFiles,
  children,
}: FilePickerProps) => {
  const [multiple, setMultiple] = useState<boolean>(false);

  let inputFileRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (allowMultiple) setMultiple(true);
    else setMultiple(false);
  }, [allowMultiple]);

  const onFileSelect = (event: ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    event.preventDefault();

    let data = [];

    if (event?.target?.files) {
      const totalFilesRead = event.target.files.length;
      let i = 0;
      for (i = 0; i < totalFilesRead; i++) {
        const fileRead = event.target.files[i];
        const file = {
          name: fileRead.name,
          extension: fileRead.name.split('.').pop(),
          file: fileRead,
        };
        data.push(file);
      }
    }
    onHandleFiles(data);
  };

  return (
    <>
      <span
        onClick={() => {
          if (inputFileRef && inputFileRef.current) {
            inputFileRef.current.click();
          }
        }}
      >
        {children}
      </span>
      <input
        type="file"
        id={id}
        ref={inputFileRef}
        onChange={onFileSelect}
        style={{ display: 'none' }}
        multiple={multiple}
      />
    </>
  );
};

export default FilePicker;
